module.exports = {"id":"150418","name":"Mario Gómez","rating":"81","photo":"./data/images/photos/0/150418.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarioGomez0.json
// module id = 2779
// module chunks = 0